var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingOvalDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 62,
    viewBox: "0 0 390 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2853_20869",
    x1: 7.08169,
    y1: -0.00000155072,
    x2: 95.6802,
    y2: 177.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C19F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064C1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 -2.563e-06V-2.563e-06C6 30.9279 31.0721 56 62 56H390",
    stroke: "url(#paint0_linear_2853_20869)",
    strokeOpacity: 0.64,
    strokeWidth: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingOvalDown);
export default __webpack_public_path__ + "97120/static/media/onboarding_oval_down.2c3974194e85abea32eb5b1de5aabb65.svg";
export { ForwardRef as ReactComponent };